import React, { Fragment } from "react";

class YellowConfirm extends React.Component {
  render() {
    return (
      <Fragment>
        <button
          style={{
            borderRadius: !this.props.allBorder ? 12 : "",
            backgroundColor: "#ffef85",
            width: this.props.width,
            padding: this.props.padding,
            boxShadow: "2px 2px 2px 0px rgba(0,0,0,0.4)",
            borderWidth: 1,
            cursor: "pointer",
            outline: 0,
            borderTopRightRadius: !this.props.allBorder ? 12 : 16,
            borderBottomRightRadius: !this.props.allBorder ? 12 : 16,
            marginLeft: !this.props.allBorder ? 0 : -1,
          }}
          onClick={this.props.action}
        >
          {this.props.text}
        </button>
      </Fragment>
    );
  }
}

export default YellowConfirm;
